import { Card } from "@lya-protect/lya-protect-form-library/dist/UI";
import classNames from "classnames";
import { ReactNode } from "react";
import "./infoCard.scss";

type InfoCardProps = {
  children: ReactNode;
  className?: string;
  icon?: "info" | "time";
  iconPosition?: "center" | "top";
};

export function InfoCard({
  children,
  className,
  icon = "info",
  iconPosition = "top",
}: InfoCardProps) {
  return (
    <Card
      variant="outline"
      className={classNames(
        "info-card",
        "card-responsive-grow",
        {
          "info-card--top-icon": iconPosition === "top",
        },
        `info-card--top-icon-${icon}`,
        className
      )}
    >
      <div className="info-card__content">{children}</div>
    </Card>
  );
}
